export const AVAILABLE_LOCALES = ['en', 'ar']

export const A_B_KEY = 'qic-qatar-travel_flow_ab_state'
export const INSURENCE_VALUES_SINGLE_PLAN_TEST_KEY = 'QATTRINSVALUES'
export const INSURENCE_VALUES_MULTI_PLAN_TEST_KEY = 'QATTRINSVALUESMULTI'
export const SELECT_PLAN_INSURANCE_VALUES_WW_WWEXCL_KEY = 'TRAVELQATINSVAL-WW_WWEXCL'
export const SELECT_PLAN_INSURANCE_VALUES_WWEXCL_KEY = 'TRAVELQATINSVAL-WWEXCL'
export const SELECT_PLAN_INSURANCE_VALUES_REG_KEY = 'TRAVELQATINSVAL-WWEXCL_REG'
export const SELECT_PLAN_INSURANCE_VALUES_EUR_KEY = 'TRAVELQATINSVAL-WWEXCL_EUR'
export const SELECT_PLAN_INSURANCE_VALUES_WW_KEY = 'TRAVELQATINSVAL-WW'
export const AIRALO_TEST_KEY = 'TRAVELQATAIRALO'
export const AIRALO_TEST_VALUES = ['TRAVELQATAIRALO-B1', 'TRAVELQATAIRALO-B2']

export const CDN_URL = 'https://webcdn.static.qic.online'
